import type { RootState } from "../../../store.ts"
import { ALL_BRANCHES } from "../../Branches/redux/branches.constants.ts"
import type {
  CompanyDefaultsAccessResponse,
  CompanyDefaultsAction,
  CompanyDefaultsBlockKey
} from "../types/company-defaults-access.types.ts"

type AccessState = Pick<RootState, "companyDefaultsAccess" | "branches">

/** The answer for the workspace now active, or `null` until it is known. */
export const selectCompanyDefaultsAccess = (
  state: AccessState
): CompanyDefaultsAccessResponse | null => {
  const slice = state.companyDefaultsAccess
  if (!slice?.access || slice.status !== "ready") return null
  const branch = state.branches?.globalBranch
  const activeTeam = !branch || branch === ALL_BRANCHES ? null : branch
  return slice.teamId === activeTeam ? slice.access : null
}

/** One block's actions for the active workspace, `undefined` until known. */
export const selectCompanyDefaultsBlock = <K extends CompanyDefaultsBlockKey>(
  state: AccessState,
  block: K
) => selectCompanyDefaultsAccess(state)?.blocks?.[block]

export const canDo = (
  access: CompanyDefaultsAccessResponse | null | undefined,
  block: CompanyDefaultsBlockKey,
  action: CompanyDefaultsAction
) =>
  (access?.blocks?.[block] as Partial<Record<string, boolean>> | undefined)?.[
    action
  ] === true
